"use client";

import type { BestIntentProfile } from "@/types/best";

import styles from "./BestIndexPage.module.css";

type BestFinderProps = {
  intents: BestIntentProfile[];
};

export function BestFinder({ intents }: BestFinderProps) {
  const hasData = intents.length > 0;

  return (
    <section className={styles.finder} aria-labelledby="best-base-finder-title" data-locked="true">
      <div className={styles.finderHeader}>
        <div className={styles.finderTopRow}>
          <span className={styles.finderBadge}>BaseForCoC finder</span>
          <span className={styles.lockedBadge}>Coming soon</span>
        </div>
        <h1 id="best-base-finder-title" className={styles.finderTitle}>BaseForCoC Base Finder</h1>
        <p className={styles.finderText}>
          This feature is being prepared. Soon you can pick a base type or strength, choose your Town Hall level, and instantly spawn the curated best base from the database.
        </p>
      </div>

      <div className={styles.finderLockedNotice}>
        <strong>Finder locked for now</strong>
        <span>
          The system is already connected to the best-base data layer, but it will unlock when enough intents and Town Hall slots are fully curated.
        </span>
      </div>

      <div className={styles.finderSentence} aria-disabled="true">
        <span>I want the</span>
        <strong>BEST</strong>
        <label className={styles.selectLabel}>
          <span className="sr-only">Base type or strength</span>
          <select value="" disabled>
            <option value="">Base type / strength</option>
          </select>
        </label>
        <span>for</span>
        <label className={styles.selectLabel}>
          <span className="sr-only">Your Town Hall level</span>
          <select value="" disabled>
            <option value="">Your Town Hall level</option>
          </select>
        </label>
        <button type="button" className={styles.goButton} disabled>
          Go!
        </button>
      </div>

      <div className={styles.finderResultSlot} data-filled="false" data-loading="false" data-locked="true">
        <div className={styles.lockedResult}>
          <div className={styles.lockIcon} aria-hidden="true">🔒</div>
          <div>
            <strong>Best base slot locked</strong>
            <span>
              {hasData
                ? "The first best-base endpoints are live, but the public finder is still in development."
                : "Best-base endpoints will appear here when the first curated slots are ready."}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
